/* Tab, Oct 30 2026 (Mordy 11:08 AM): full-screen mobile menu (snippets/tab-mobile-menu.liquid). Under 990px only. */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');
  function $(s, r) { return (r || document).querySelector(s); }

  function init() {
    var panel = document.getElementById('TabMobileMenu');
    var trig = $('.tab-mm-trigger');
    if (!panel || !trig || panel.dataset.tabMmReady) return;
    panel.dataset.tabMmReady = '1';
    document.body.appendChild(panel); // out of the sticky header so position:fixed covers the whole screen

    var closeBtn = $('[data-tab-mm-close]', panel);
    var lastFocus = null;

    // Closed header: menu button + circle rings follow the colour of the theme's own header icons (white on photo heroes, dark elsewhere)
    var raf = 0;
    function syncColor() {
      raf = 0;
      var ref = $('.section-header .header__icon--search svg') || $('.section-header .header__icon--cart svg');
      if (!ref) return;
      var c = getComputedStyle(ref).color;
      var root = document.documentElement.style;
      root.setProperty('--tab-mm-ic', c);
      var m = c.match(/\d+(\.\d+)?/g);
      var light = m && (+m[0] + +m[1] + +m[2]) > 600;
      root.setProperty('--tab-mm-ring', light ? 'rgba(255,255,255,0.35)' : 'rgba(39,45,51,0.1)');
    }
    function queueSync() { if (!raf) raf = requestAnimationFrame(syncColor); }
    syncColor();
    window.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);
    setTimeout(syncColor, 600); setTimeout(syncColor, 2000);

    function syncCount() {
      var b = $('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
      var cnt = $('.tab-mm__count', panel);
      if (!cnt) return;
      var n = b ? parseInt(b.textContent, 10) || 0 : 0;
      cnt.textContent = n; cnt.hidden = n === 0;
    }

    function open() {
      lastFocus = document.activeElement;
      syncCount();
      panel.hidden = false;
      document.documentElement.classList.add('tab-mm-lock');
      trig.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      setTimeout(function () { closeBtn && closeBtn.focus({ preventScroll: true }); }, 50);
    }
    function close(restoreFocus) {
      if (panel.hidden) return;
      panel.classList.remove('is-open');
      panel.hidden = true;
      document.documentElement.classList.remove('tab-mm-lock');
      trig.setAttribute('aria-expanded', 'false');
      if (restoreFocus !== false) (lastFocus && lastFocus.focus ? lastFocus : trig).focus({ preventScroll: true });
    }

    trig.addEventListener('click', function (e) { e.preventDefault(); panel.hidden ? open() : close(); });
    closeBtn && closeBtn.addEventListener('click', function () { close(); });

    // Search: close the menu, then open the theme's own search (header search modal)
    var sBtn = $('[data-tab-mm-search]', panel);
    sBtn && sBtn.addEventListener('click', function () {
      close(false);
      var s = $('.section-header details-modal.header__search summary') || $('.section-header .header__icon--search');
      // next tick: the theme's search modal closes itself on the body click this same tap is still bubbling to
      if (s) setTimeout(function () { s.click(); }, 0); else window.location.href = '/search';
    });

    // Bag: close the menu, then do exactly what the header bag does (opens the cart drawer; /cart without JS)
    var cBtn = $('[data-tab-mm-cart]', panel);
    cBtn && cBtn.addEventListener('click', function (e) {
      var hb = document.getElementById('cart-icon-bubble');
      if (hb && document.querySelector('cart-drawer')) { e.preventDefault(); close(false); setTimeout(function () { hb.click(); }, 0); }
    });

    // Adults dropdown
    panel.querySelectorAll('.tab-mm__toggle').forEach(function (t) {
      t.addEventListener('click', function () {
        var sub = document.getElementById(t.getAttribute('aria-controls'));
        var on = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (sub) sub.hidden = !on;
      });
    });

    // Links that only point at the current page anchor (#) just close the menu
    panel.querySelectorAll('a[href="#"]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); close(); }); });

    document.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') { // keep focus inside the panel
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    var onMq = function () { if (!mq.matches) close(false); };
    mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);
    window.addEventListener('pageshow', function () { close(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
